import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@angular/material';

import { DataTableModule, CalendarModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';

import { PaymentsComponent } from './payments.component';
import { PaymentListComponent } from './paymentlist/payment-list.component';
import { PaymentComponent } from './payment/payment.component';
import { SyncCitcoComponent } from './synccitco/sync-citco.component';

@NgModule({
    declarations: [
        PaymentsComponent,
        PaymentListComponent,
        PaymentComponent,
        SyncCitcoComponent,
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule
    ],
    providers: [],
    entryComponents: [
        PaymentComponent,
        SyncCitcoComponent,
    ]
})

/**
 * Main module for the payment managements.
*/
export class PaymentsModule { }



// WEBPACK FOOTER //
// ./src/app/finance/payments/payments.module.ts